import axios from "axios";
import i18next from "i18next";


export const postHelp = (apiKey, message) => axios({
        url: 'https://api.es-europe.eu/help',
        method: 'POST',
        headers: {
            token: apiKey
        },
        data: {
            message: message
        }
    })
    .catch(error => Promise.reject(i18next.t('Nepodařilo se odeslat zprávu')));